"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnexpectedError = void 0;
const ResponseError_1 = require("./ResponseError");
class UnexpectedError extends ResponseError_1.ResponseError {
    constructor(message = "Unexpected error.", status) {
        super("Unexpected error.", message, status);
    }
}
exports.UnexpectedError = UnexpectedError;
//# sourceMappingURL=UnexpectedError.js.map